export const WS_CONNECT = 'WS_CONNECT';
export const WS_SEND = 'WS_SEND';
export const WS_DISCONNECT = 'WS_DISCONNECT';
export const WS_SUBSCRIBE = 'WS_SUBSCRIBE';
export const WS_SUBSCRIBE_FULFILLED = 'WS_SUBSCRIBE_FULFILLED';
export const WS_UNSUBSCRIBE = 'WS_UNSUBSCRIBE';
export const WS_UNSUBSCRIBE_FULFILLED = 'WS_UNSUBSCRIBE_FULFILLED';
